import {Constants} from "../../constants";
import {CatalogComponent} from "./catalog.component";
import {Routes} from "@angular/router";

export const CATALOG_ROUTES: Routes = [
    {
        path: Constants.CATALOG_STATE + '/:categoryId',
        component: CatalogComponent,
        data: {
            roles: [Constants.ROLES.ANY],
            restrict: [Constants.ROLES.NFR_MHP_ONLY],
            restrictGroup: [[Constants.ROLES.CBEC, Constants.ROLES.RETAIL]]
        }
    },
    {
        path: Constants.TAG_CATALOG_STATE + '/:tagId',
        component: CatalogComponent,
        data: {
            roles: [Constants.ROLES.ANY],
            restrict: [Constants.ROLES.NFR_MHP_ONLY],
            restrictGroup: [[Constants.ROLES.CBEC, Constants.ROLES.RETAIL]]
        }
    }
];
